import React from 'react';
import { Button as BootstrapButton } from 'react-bootstrap';

import Icon from '@components/custom/Icon';

const Button = ({
  className = '',
  disabled = false,
  icon = false,
  iconName = '',
  iconSize = 18,
  iconStyle = {},
  label = '',
  onClick,
  type = 'button',
  ...rest
}) => {
  return (
    <BootstrapButton
      type={ type }
      className={ `btn-sm ${className}` }
      disabled={ disabled }
      onClick={ onClick }
      { ...rest }
    >
      {icon && (
        <Icon name={ iconName } color="#ffffff" size={ iconSize } style={ iconStyle } />
      )}
      { label }
    </BootstrapButton>
  );
};

export default Button;